<div
  [ngClass]="{
    'menu-content': true,
    'menu-content-shadow': true,
    'menu-content--collapsed': isMenuCollapsed,
    'menu-content--notificationShowed': notification$ | async,
  }">
  <div class="menu-button" (click)="collapseMenu()" [attr.data-test]="'header_menu'">
    @switch (sessionFacade.branding$ | async) {
      @case (CustomBranding.sparkasse) {
        <img
          *ngIf="!menuCollapsed"
          class="image"
          ngSrc="assets/branding/sparkasse/eMobility_Plattform_logo_red.svg"
          alt="Sparkasse eMobility Logo"
          height="20"
          width="150" />
        <eop-icon
          *ngIf="!menuCollapsed"
          identifier="chevron-left-sq-outlined"
          [clickable]="true"
          [color]="IconColor.INHERIT"
          [vaylensFont]="true"
          class="menu-icon"></eop-icon>
        <img
          *ngIf="menuCollapsed"
          class="image"
          ngSrc="assets/branding/sparkasse/sparkasse_logo_red.svg"
          alt="Sparkasse Logo"
          height="20"
          width="20" />
      }
      @case (CustomBranding.enercity) {
        <img
          *ngIf="!menuCollapsed"
          class="image"
          ngSrc="assets/branding/enercity/enercity-mobility-logo.png"
          alt="enercity Ladepunkt Logo"
          height="47"
          width="140" />
        <eop-icon
          *ngIf="!menuCollapsed"
          identifier="chevron-left-sq-outlined"
          [clickable]="true"
          [color]="IconColor.INHERIT"
          [vaylensFont]="true"
          class="menu-icon"></eop-icon>
        <img
          *ngIf="menuCollapsed"
          class="image"
          ngSrc="assets/branding/enercity/enercity-mobility-icon.png"
          alt="enercity Ladepunkt Logo"
          height="20"
          width="20" />
      }
      @case (CustomBranding.komma) {
        <img
          *ngIf="!menuCollapsed"
          class="image"
          ngSrc="assets/branding/1komma5/1K5-Logo-Signet-weiss.svg"
          alt="1KOMMA5 Logo"
          height="24"
          width="73" />
        <eop-icon
          *ngIf="!menuCollapsed"
          identifier="chevron-left-sq-outlined"
          [clickable]="true"
          [color]="IconColor.INHERIT"
          [vaylensFont]="true"
          class="menu-icon"></eop-icon>
        <img
          *ngIf="menuCollapsed"
          class="image"
          ngSrc="assets/branding/1komma5/1K5-Logo-Signet-aubergine.svg"
          alt="1KOMMA5 Logo"
          height="16"
          width="26" />
      }
      @default {
        <img
          *ngIf="!menuCollapsed"
          class="image"
          ngSrc="assets/img/logo/vaylens_full.svg"
          alt="Vaylens Logo"
          height="24"
          width="91" />
        <eop-icon
          *ngIf="!menuCollapsed"
          identifier="chevron-left-sq-outlined"
          [clickable]="true"
          [color]="IconColor.INHERIT"
          [vaylensFont]="true"
          class="menu-icon"></eop-icon>
        <img
          *ngIf="menuCollapsed"
          class="image"
          ngSrc="assets/img/logo/vaylens_small.svg"
          alt="Vaylens Logo"
          height="16"
          width="16" />
      }
    }
  </div>

  <div class="menu-inner-content">
    <mat-accordion displayMode="flat" class="menu--accordion" [multi]="false">
      <eop-menu-group
        [menuPoints]="menuPoints"
        [menuCollapsed]="menuCollapsed"
        [activeGroupName]="activeMenuGroup"
        (activeGroupChange)="onMenuGroupChange($event)"></eop-menu-group>
    </mat-accordion>
    <eop-user-menu
      [menuCollapsed]="menuCollapsed"
      [activeGroupName]="activeMenuGroup"
      (activeGroupChange)="onMenuGroupChange($event)"></eop-user-menu>
    <eop-menu-group
      [menuPoints]="legalMenuPoints"
      [menuCollapsed]="menuCollapsed"
      [activeGroupName]="activeMenuGroup"
      (activeGroupChange)="onMenuGroupChange($event)">
    </eop-menu-group>
    <eop-menu-footer [menuCollapsed]="menuCollapsed"> </eop-menu-footer>
  </div>
</div>

<div
  [ngClass]="{ backdrop: screenWidth < $screenWidthDesktopMax && !isMenuCollapsed }"
  (click)="collapseMenu()"></div>
